module.exports = __webpack_public_path__ + "static/banner-img2-2bc51982844c25a6ab18a294f5d79b0c.png";